import { loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm, monitoringOff, monitoringOn } from '@assets/images/main/index';
import {
  Icon3d3d,
  Icon3dAlert,
  Icon3dCheck,
  Icon3dCycle,
  Icon3dDetect,
  Icon3dLocation,
  Icon3dMap2,
  Icon3dMeter,
  Icon3dSchedule,
  Icon3dServer,
  IconDownload,
} from '@assets/images/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  iotBannerBg,
  iotBannerProduct,
  iotScreenshot1D,
  iotScreenshot1M,
  iotScreenshot1T,
  iotScreenshot2D,
  iotScreenshot2M,
  iotScreenshot2T,
  iotScreenshot3D,
  iotScreenshot3M,
  iotScreenshot3T,
} from '@assets/images/main/sensor';
import { IconAirQualityInv, IconBellInv, IconCo2Inv, IconLoraSensorInv } from '@assets/images/main/icon';
import { screenViewIot1, screenViewIot2, screenViewIot3, screenViewIot4 } from '@assets/images/main/screenView';

import IconAirOff from '@assets/images/main/screenView/iot/airIcon.png';
import IconFireOff from '@assets/images/main/screenView/iot/fireIcon.png';
import IconRobotOff from '@assets/images/main/screenView/iot/robotIcon.png';
import IconJetpanOff from '@assets/images/main/screenView/iot/jetpanIcon.png';
import IconAirOn from '@assets/images/main/screenView/iot/airIconOn.png';
import IconFireOn from '@assets/images/main/screenView/iot/fireIconOn.png';
import IconRobotOn from '@assets/images/main/screenView/iot/robotIconOn.png';
import IconJetpanOn from '@assets/images/main/screenView/iot/jetpanIconOn.png';

export default {
  banner: {
    title: '複雑な機器も、多様なデータも、<br/>ORBROなら一つのシステムのように動作します。',
    desc: '温湿度、空気質、圧力、CO₂、侵入検知、電力制御、非常ベルなど、<br/>現場のIoTデータが ORBRO OS にリアルタイムで収集・可視化されます。',

    schemeTitle: '産業現場に最適なセンサー、ORBROがご用意します。',
    bgImg: iotBannerBg,
    productImg: iotBannerProduct,
  },

  func: {
    title: '機能をもっと見る',
    desc: 'センサーのさまざまな機能をご確認ください。',

    data: [
      {
        img: Icon3dMap2,
        title: 'センサー状態のリアルタイム監視',
        desc: 'センサーの動作状態、バッテリー残量、接続信号強度を ORBRO OS 上でリアルタイムに確認できます。',
      },
      {
        img: Icon3dCheck,
        title: '地図上でのセンサー配置確認',
        desc: 'センサーの設置位置を地図や図面上に可視化し、エリアごとの状態を一目で確認できます。',
      },
      {
        img: Icon3dSchedule,
        title: 'イベント履歴および通知ログの確認',
        desc: '発生した異常イベントと送信された通知履歴をタイムラインで確認し、原因分析に活用できます。',
      },
      {
        img: Icon3dLocation,
        title: 'エリア別セーングループ管理',
        desc: '設置エリアや用途ごとにセンサーをグループ化し、ダッシュボードで直感的に管理できます。',
      },
      {
        img: Icon3dAlert,
        title: '異常検出としきい値設定',
        desc: 'センサーごとにしきい値を設定し、超過時にはシステムが自動で検出し通知を送信します。',
      },
      {
        img: Icon3dAlert,
        title: 'エリア別の通知条件調整',
        desc: 'リスクの高いエリアにはより敏感な通知条件を設定するなど、アラート感度を柔軟に調整できます。',
      },
      {
        img: IconDownload,
        title: 'データ履歴の保存およびダウンロード',
        desc: '測定値とイベント履歴が自動的に保存され、CSVまたはExcel形式でエクスポート可能です。',
      },
      {
        img: Icon3dServer,
        title: '外部システム連携（API）',
        desc: '出入口制御、設備制御など外部システムとの連携用APIを提供し、イベントトリガーベースの自動化が可能です。',
      },
    ],
  },

  bannerData: [
    {
      icon: loraSensorOn,
      iconInv: IconLoraSensorInv,
      iconOff: loraSensorOff,
      image: '',
      iconText: 'LoRAセンサー',
      sub: 'New',
      link: '/jp/iot/LoRASensor',
    },
    {
      icon: coOn,
      iconInv: IconCo2Inv,
      iconOff: coOff,
      image: '',
      iconText: 'CO₂測定器',
      sub: 'New',
      link: '/jp/iot/co2',
    },
    {
      icon: airOn,
      iconInv: IconAirQualityInv,
      iconOff: airOff,
      image: '',
      iconText: '空気質モニター',
      sub: 'New',
      link: '/jp/iot/air',
    },
    {
      icon: monitoringOn,
      iconInv: IconBellInv,
      iconOff: monitoringOff,
      image: '',
      iconText: '非常ベル',
      sub: '',
      link: '/jp/iot/bell',
    },
  ],
  screenView: {
    title: '多様なセンサーと統合による拡張',
    data: [
      { icon: IconAirOff, iconOn: IconAirOn, text: '空気質センサーモニタリング', img: screenViewIot1 },
      { icon: IconFireOff, iconOn: IconFireOn, text: '火災警報器連携', img: screenViewIot2 },
      { icon: IconAirOff, iconOn: IconAirOn, text: '配送ロボット連携', img: screenViewIot3 },
      { icon: IconAirOff, iconOn: IconAirOn, text: 'ジェットファン連携', img: screenViewIot4 },
    ],
  },
  screenShot: [
    {
      title: 'すべてのセンサーを一目で確認できるリアルタイム統合ダッシュボード',
      desc: '多様なIoTセンサーのデータを ORBRO OS 上でリアルタイムに可視化し、<br/>位置とセンサー情報を一画面で直感的に管理できます。',
      img: {
        desktop: iotScreenshot1D,
        tablet: iotScreenshot1T,
        mobile: iotScreenshot1M,
      },
    },
    {
      title: '時系列で確認できるセンサーデータグラフ',
      desc: 'センサーごとの測定値を時間帯別のグラフで確認し、環境変化や異常兆候を素早く把握できます。',
      img: {
        desktop: iotScreenshot2D,
        tablet: iotScreenshot2T,
        mobile: iotScreenshot2M,
      },
    },
    {
      title: '異常が検出されたら即時通知で対応開始',
      desc: 'センサーが設定値を超える、または異常を検知した場合、ORBRO OS は即座に管理者へ通知を送り、迅速な対応を支援します。',
      img: {
        desktop: iotScreenshot3D,
        tablet: iotScreenshot3T,
        mobile: iotScreenshot3M,
      },
    },
  ],

  FAQ: [
    {
      title: 'センサーデータはどれくらいの頻度で更新されますか？',
      description: '標準設定は1～5分間隔で、センサーの種類によってはリアルタイム伝送にも対応しています。',
    },
    {
      title: 'オフライン環境でも動作しますか？',
      description: '一部のセンサーはローカルにデータを保存し、ネットワーク復旧後に送信可能です。',
    },
    {
      title: '複数のセンサーを同時に設置できますか？',
      description: 'ORBRO OSは複数のセンサーを同時に接続・管理できるように設計されています。',
    },
    {
      title: '外部機器との連携は可能ですか？',
      description: 'APIを通じて、制御システムや出入口システムなど様々な機器と柔軟に連携可能です。',
    },
    {
      title: 'センサーのバッテリーはどれくらい持ちますか？',
      description: '製品によりますが、LoRaセンサーは平均して6ヶ月〜1年以上使用可能で、バッテリー状態もリアルタイムで確認できます。',
    },
    {
      title: 'すべてのセンサーが ORBRO OS に連携されますか？',
      description: 'ORBRO認定製品はすべて自動で連携され、Modbus、RS-485 など通信方式が一致する他社製センサーも一部対応可能です。',
    },
    {
      title: 'センサーの異常動作時に通知を受け取れますか？',
      description: 'はい。通信断、バッテリー不足などの異常をシステムが自動検知して通知します。',
    },
    {
      title: '通知を複数人が同時に受け取れますか？',
      description: '可能です。部門別や役割別に通知グループを設定できます。',
    },
  ],
};
